import {ChipList} from '@ui/forms/input-field/chip-field/chip-list';
import {Chip} from '@ui/forms/input-field/chip-field/chip';
import {Trans} from '@ui/i18n/trans';
import React from 'react';

export function EnumLinkQualityChip({quality}: {quality: string}) {
  return (
    <ChipList radius="rounded" size="xs">
      <Chip key={quality} selectable>
        <Trans message={quality} />
      </Chip>
    </ChipList>
  );
}
